module.exports = __webpack_public_path__ + "static/media/jersey.5faa9681.jpeg";